namespace('compass.hotel');

compass.requireLib('compass.util.parse');
compass.requireLib('compass.util.format');

compass.hotel.RoomTypesWidget = compass.defineWidget(function RoomTypesWidget(options) {
	var me = this;
	var $j = jQuery;
	var _d = jQuery.dom.getContext(this);

	var _settings = options;
	_settings.roomTypes = _settings.roomTypes || _settings.hotel.roomTypes;
	_settings.avail = _settings.avail || _settings.hotel.avail;

	// this should be called preHandleClick. For backwards compitbility support argument named sortRoomTypes. sweep if time.
	_settings.preHandleClick = _settings.preHandleClick || _settings.sortRoomTypes;

	var _currentRoomType = null;
	var _cf = _settings.meetingInfo.defaultCurrencyFormatter;

	var _checkInDate = _settings.checkInDate;
	var _checkOutDate = _settings.checkOutDate;

	var _labelId = compass.generateId();

	this.grabValues = function() {
		var jsonValues = {};
		if(_currentRoomType) {
			jsonValues.roomTypeID = _currentRoomType.blockedRoomId;
			jsonValues.blocked_room_id = _currentRoomType.blockedRoomId;
			jsonValues.roomTypeName = _currentRoomType.name;
			jsonValues.occupants = _currentRoomType.occupants;
		}
		return jsonValues;
	};

	this.setupControls = function() {
		_currentRoomType = _settings.initialSelection ? _.find(_settings.roomTypes, function(rt) { return rt.blockedRoomId === _settings.initialSelection; }) : _.first(_settings.roomTypes);
	};

	this.render = function(widgetElem) {
		var d = _d;
		me.setupControls();

		var roomTypesReader = (_settings.reservationsExists) ? 'Adjust ' : 'Select ';
		widgetElem.append(
			d.h4({ className: 'RoomTypesLabel', id : _labelId }, 
				d.reader(roomTypesReader),
				'Room Type'),
				me.drawRoomTypes()
		);
	};

	function _roomTypeChanged(data) {
		_currentRoomType = data;
		me.trigger("RoomTypesWidget.roomTypeChanged", _currentRoomType.blockedRoomId);
		/*warning: _settings.onChange has to occur AFTER me.trigger("RoomTypesWidget.roomTypeChanged" so that there's time to validate dates */
		/* this will allow the onChange handler to enable/disable submit buttons correctly based on the freshest validation of dates*/
		_settings.onChange(data);
	}

	this.drawRoomTypes = function() {
		var d = _d;

		function choiceMapper(rt) {
			var _drawSoldOut = function() {
				var limitedText = '';
				// drives the crossing out of the room type name
				if(_settings.showAvail) {
					if(rt.requestedDatesAvail !== true) {
						return d.div({ className : 'roomTypeSoldOut' }, _settings.labels.soldOut);
					} else {
						if(rt.limitedAvail) {
							var maxRoomsXDateRange = _settings.availabilityMapper(rt);
							if(maxRoomsXDateRange){
								limitedText = maxRoomsXDateRange + ' rooms';
							}
							return d.div({ className : 'roomTypeLimitedAvail' }, limitedText);
						} else {
							return '';
						}
					}
				}
			};

			var _drawPrice = function(avgNightlyRate) {
				if(_settings.showPrice) {
					return d.div({ className : 'roomTypeSelectColumn price' }, _cf(Math.round(avgNightlyRate)));
				}
			};

			var option = d.div({ title : rt.name });
			if(rt.nights.length > 0 && _settings.avail.status != 'GDS' ) {
				var avgNightlyRate = _settings.rateMapper(rt);
				if (rt.occupants > 1) {
					option.addClass('multiOccupancy');
				}
				option.append(
					_drawPrice(avgNightlyRate),
					d.div({ className : 'roomTypeSelectColumn roomType' }, rt.name),
					_drawSoldOut()
				);
			} else {
				option.append(
					d.div({ className : 'roomTypeSelectColumn roomType' }, rt.name)
				);
			}

			return option;
		}

		var getClassMapper = function() {
			var _blockClassMapper = function(data) { 
				if(data.requestedDatesAvail !== true) { return 'soldout'; }
				else if(data.limitedAvail === true)	{ return 'limitedAvail'; }
				else { return ''; }
			};
			return _settings.isGDS ? function(){} : _blockClassMapper;
		};

		var initialSelectionIndex = -1;
		for (var i = 0; i < _settings.roomTypes.length; i++) {
				if (_.isEqual(_settings.roomTypes[i], _currentRoomType)) {
						initialSelectionIndex = i;
						break;
				}
		}
		return d.dataSelect({
			data : _settings.roomTypes,
			className : 'roomTypesSelect',
			classMapper :	_settings.classMapper || getClassMapper(),
			disabledClassName: 'soldout',
			change : _roomTypeChanged,
			labelMapper : function(data) { return data.name; },
			choiceMapper : choiceMapper,
			initialSelection : initialSelectionIndex,
			idGenerator : compass.generateId,
			labelledBy : _labelId,
			preHandleClick : _settings.preHandleClick
		});
	};

}, {
	WUID : 'defaultRoomTypesWidgetWUID',
	widgetName : 'RoomTypesWidget',
	roomTypes: false,
	hotel : { "avail" : {"status" : "normal"} },
	avail : false,
	labels : {
		soldOut : 'UNAVAILABLE'
	},
	reservationsExists : false,
	initialSelection : undefined,
	requestedRooms : 1,
	sortRoomTypes : function() {return true; /* get passed to data select prehandle click which treat undefined as true but should be explicit */ },
	preHandleClick : null,
	rateMapper : function() { },
	classMapper : false,
	onChange : function() { },
	availabilityMapper : function() { },
	checkInDate : '',
	checkOutDate : '',
	isGDS : false,
	showAvail: true,
	showPrice: true
});

